
<template>
<Loader v-if="loader" />

  <div class="card fattura-voci">
    <Toolbar class="p-mb-4">
      <template #start>
          <Button label="Nuova voce" icon="pi pi-plus" class="p-button-success mr-2" @click="openNew" />
      </template>
    </Toolbar>
    <DataTable :value="items" editMode="row" dataKey="id" v-model:editingRows="editingRows" @row-edit-save="onRowEditSave" responsiveLayout="scroll"
    :paginator="true" :rows="20" :filters="filters" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
    :rowsPerPageOptions="[10,20,50]" currentPageReportTemplate="{first} a {last} di {totalRecords}">
        <template #header>
                <div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                    </span>
                </div>
            </template>
        <template #empty>
            <div class="text-center">Nessun dato trovato.</div>
        </template>

        <Column field="code" header="Code" :sortable="true">
            <template #editor="{ data, field }">
                <InputText v-model="data[field]" />
            </template>
        </Column>
        <Column field="descrizione" header="Descrizione">
            <template #editor="{ data, field }">
                <InputText v-model="data[field]" />
            </template>
        </Column>
        <Column field="cod_type_prezzo" header="Prezzo" style="width:20%">
            <template #editor="{ data, field }">
                <Dropdown v-model="data[field]" :options="prices" optionLabel="description" optionValue="id" placeholder="Seleziona">
                    <template #option="slotProps">
                        <span>{{slotProps.option.description}}</span>
                    </template>
                </Dropdown>
            </template>
            <template #body="{ data }">
              {{data.prezzo_name}}
              <!-- {{getPrezzoLabel(data[field])}} -->
            </template>
        </Column>
        <Column field="cod_section" header="Sezione" style="width:20%">
            <template #editor="{ data, field }">
                <Dropdown v-model="data[field]" :options="sections" optionLabel="name" optionValue="id" placeholder="Seleziona">
                    <template #option="slotProps">
                        <span>{{slotProps.option.name}}</span>
                    </template>
                </Dropdown>
            </template>
            <template #body="{data}">
                {{data.sezione_name}}
            </template>
        </Column>
        <Column field="codiceConto" header="Conto EE">
            <template #editor="{ data, field }">
                <InputText v-model="data[field]" autofocus />
            </template>
        </Column>
        <Column field="codiceContoGAS" header="Conto GAS">
            <template #editor="{ data, field }">
                <InputText v-model="data[field]" autofocus />
            </template>
        </Column>
        <Column :rowEditor="true" style="width:10%; min-width:8rem" bodyStyle="text-align:center"></Column>
        <Column :exportable="false">
            <template #body="{data}">
                <button @click="confirmDeleteItem(data)" class="p-row-editor-init p-link" type="button">
                  <span class="p-row-editor-init-icon pi pi-fw pi-trash"></span>
                </button>
            </template>
        </Column>
    </DataTable>
  </div>


  <!-- Dialog new user -->
  <Dialog v-model:visible="newItemDialog" :style="{width: '90%'}" header="Nuovo utente" :modal="true" class="p-fluid">
  <div class="grid" style="min-height:150px">
    <div class="col-12 md:col-3">
      <div class="p-field">
        <label>Code</label>
        <InputText  v-model.trim="newItem.code" required="true" autofocus :class="{'p-invalid': validationErrors.code && submitted}" :value="newItem.code" />
        <small class="p-error" v-if="validationErrors.code && submitted">Campo richiesto</small>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="p-field">
        <label>Descrizione</label>
        <InputText  v-model.trim="newItem.descrizione" required="true" autofocus :class="{'p-invalid': validationErrors.descrizione && submitted}" :value="newItem.descrizione" />
        <small class="p-error" v-if="validationErrors.descrizione && submitted">Campo richiesto</small>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="p-field">
        <label>Prezzo</label>
        <Dropdown v-model="newItem.cod_type_prezzo" :options="prices" optionLabel="description" optionValue="id" placeholder="Seleziona" :class="{'p-invalid': validationErrors.cod_type_prezzo && submitted}" />
        <small class="p-error" v-if="validationErrors.cod_type_prezzo">Campo richiesto</small>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="p-field">
        <label>Sezione</label>
        <Dropdown v-model="newItem.cod_section" :options="sections" optionLabel="name" optionValue="id" placeholder="Seleziona" :class="{'p-invalid': validationErrors.cod_section && submitted}" />
        <small class="p-error" v-if="validationErrors.cod_section">Campo richiesto</small>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="p-field">
        <label>Conto EE</label>
        <InputText  v-model.trim="newItem.codiceContoEE" required="true" autofocus :class="{'p-invalid': validationErrors.codiceContoEE && submitted}" :value="newItem.codiceContoEE" />
        <small class="p-error" v-if="validationErrors.codiceContoEE && submitted">Campo richiesto</small>
      </div>
    </div>
    <div class="col-12 md:col-3">
      <div class="p-field">
        <label>Conto GAS</label>
        <InputText  v-model.trim="newItem.codiceContoGAS" required="true" autofocus :class="{'p-invalid': validationErrors.codiceContoGAS && submitted}" :value="newItem.codiceContoGAS" />
        <small class="p-error" v-if="validationErrors.codiceContoGAS && submitted">Campo richiesto</small>
      </div>
    </div>
  </div>
  <template #footer>
    <Button label="Annulla" icon="pi pi-times" class="p-button-danger" @click="newItemDialog = false" />
    <Button label="Salva" icon="pi pi-check" class="p-button-success mr-2"  @click="saveNewItem" />
  </template>
  </Dialog>


<!-- Dialog delete user -->
<Dialog v-model:visible="deleteItemDialog" :style="{width: '450px'}" header="Conferma eliminazione" :modal="true">
    <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="selectedItem">Confermi la cancellazione di {{selectedItem.code}}</span>
    </div>
    <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteItemDialog = false"/>
        <Button label="Si" icon="pi pi-check" class="p-button-text" @click="deleteSelectedItem" />
    </template>
</Dialog>

    
</template>

<script>

import { FilterMatchMode } from 'primevue/api';
import UtilityService from '@/services/ask-management/utility-service'
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance  } from 'vue';
import Loader from '@/components/Loader.vue'

export default {
    components: {
      Loader
    },
     setup() {
        const loader = ref(false);
        const filters = ref({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        });
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        self.$http = self.appContext.config.globalProperties.$http
        const service = new Service(self.$http, self.$eventBus)
        const utilityService = new UtilityService(self.$http, self.$eventBus)
        const submitted = ref(false);
        const validationErrors = ref({})
        const items = ref([]);
        const sections = ref([]);
        const prices = ref([]);
        const selectedItem = ref();
        const editingRows = ref([]);
        const newItem= ref({});
        const newItemDialog = ref(false);
        const deleteItemDialog = ref(false);

        onMounted(() => {
          getFatturaSezioni()
          getFatturaTypePrezzo()      
          getData() 
        })

        const getFatturaSezioni = () => {
          utilityService.getFatturaSezioni().then((res) => {
            sections.value = res.items.data
          })
        }

        const getFatturaTypePrezzo = () => {
          utilityService.getFatturaTypePrezzo().then((res) => {
            prices.value = res.items.data
          })
        }

        const getData = () => {
          loader.value = true;
          utilityService.getFatturaVoci().then((res) => {
            items.value = res.items.data
          }).finally(() => {
              loader.value = false;
          })
        }

        const onRowEditSave = (event) => {
          loader.value = true;
          let { newData, index } = event;
          let newPrezzo = prices.value.filter(el => el.id == newData.cod_type_prezzo)
          let newSezione = sections.value.filter(el => el.id == newData.cod_section)
          newData.prezzo_name = newPrezzo.length > 0 ? newPrezzo[0].description : ''
          newData.sezione_name = newSezione.length > 0 ? newSezione[0].name : ''

          service.editFatturaVoci(newData).then((res) => {
            if (res) {
              items.value[index] = newData;
            }
          }).finally(() => {
              loader.value = false;
          })
        };

        const openNew = () => {
          newItem.value = {}
          submitted.value = false;
          newItemDialog.value = true;
        };
        const saveNewItem = () => {
          submitted.value = true;
          if (validateForm()) {
            loader.value = true;
            service.createFatturaVoce(newItem.value).then((res) => {
              if (res) {
                getData()
              }
            }).finally(() => {
              newItemDialog.value = false;
              loader.value = false;
            })
          }         
        };

        const confirmDeleteItem= (item) => {
          selectedItem.value = item
          deleteItemDialog.value = true;
        };

        const deleteSelectedItem = () => {
          loader.value = true;
          service.deleteFatturaVoci(selectedItem.value).then((res) => {
            if (res) {
              getData()
            }
          }).finally(() => {
            deleteItemDialog.value = false;
            loader.value = false;
          })
        }


        const validateForm = () => {
          if (newItem.value.code && newItem.value.code != '')
            delete validationErrors.value['code'];
          else
            validationErrors.value['code'] = true;

          if (newItem.value.descrizione && newItem.value.descrizione != '')
            delete validationErrors.value['descrizione'];
          else
            validationErrors.value['descrizione'] = true;
            
          if (newItem.value.cod_type_prezzo)
            delete validationErrors.value['cod_type_prezzo'];
          else
            validationErrors.value['cod_type_prezzo'] = true;

          if (newItem.value.cod_section)
            delete validationErrors.value['cod_section'];
          else
            validationErrors.value['cod_section'] = true;
              
          return !Object.keys(validationErrors.value).length;
        }

        
        return { 
          items,
          sections,
          prices,
          loader,
          submitted,
          validationErrors,
          filters,
          editingRows,
          onRowEditSave,
          newItem,
          newItemDialog,
          openNew,
          saveNewItem,
          confirmDeleteItem,
          selectedItem,
          deleteItemDialog,
          deleteSelectedItem,
          validateForm
         }
    }
}
</script>
<style>
.fattura-voci .p-row-editor-init:hover  .pi-pencil{
   color: #2196f3 !important;
}
.fattura-voci .p-row-editor-init:hover  .pi-trash{
   color: #f93d3d !important;
}
</style>
